module.exports = __webpack_public_path__ + "img/02.辽柏（杨树田-摄）.d66781b5.jpg";